module.exports = __webpack_public_path__ + "svg/cancer.svg?2e7af9f91333e8428cb68ba98fb6adc4";